import React from "react";
import PropTypes from "prop-types";
import { useAuthLogic } from "../../hooks/useAuth";
import AuthView from "./AuthView";

export default function Auth({ onSignIn }) {
  const {
    email,
    setEmail,
    password,
    setPassword,
    error,
    handleSignInWithEmail
  } = useAuthLogic(onSignIn);

  return (
    <AuthView
      email={email}
      setEmail={setEmail}
      password={password}
      setPassword={setPassword}
      error={error}
      onSignInClick={handleSignInWithEmail}
    />
  );
}

Auth.propTypes = {
  onSignIn: PropTypes.func.isRequired,
};
